import { useSelector } from 'react-redux'
import React from 'react'
import { StateExtended } from '../../_config/interfaces'

export function useAuthStatus() {
    const user = useSelector((state: StateExtended) => state.user)
    return user?.isAuthenticated
}
export function useUserSelector() {
    const user = useSelector((state: StateExtended) => state.user)
    return user?.user
}
